// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ct-view {
  width: 100%;
}

.catalog-transfer-wrapper .content-header .data-container .right-data {
  align-items: flex-end;
}

.ct-status-pill {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ct-status-pill-label {
  font-size: 1.6rem;
  font-weight: 600;
}

.ct-view-heading {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 2.5rem;
}

.ct-review-actions {
  background: #f2f2f2;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 18px 20px;
  margin: 10px 0 30px;
  width: fit-content;
  min-width: 210px;
}

.ct-review-actions-title {
  font-weight: 600;
  margin-bottom: 10px;
}

.ct-review-actions-buttons {
  display: flex;
  gap: 18px;
  width: fit-content;
}

.ct-review-note {
  margin: 16px 0;
}

.ct-decision-summary {
  background: #f2f2f2;
  border-radius: 4px;
  padding: 14px 16px;
  margin: 10px 0 30px;
  width: 210px;
}

.ct-decision-summary-title {
  font-weight: 600;
  margin-bottom: 4px;
}

.ct-decision-summary-value {
  margin: 0;
}

.ct-decision-popup {
  max-width: 60rem;
  width: min(60rem, 100%);
}

.ct-decision-popup-inner h2 {
  margin-bottom: 12px;
}
.ct-decision-popup-inner > p {
  margin: 0 0 16px;
}

.ct-decision-popup-description {
  margin: 8px 0 16px;
}

.ct-decision-popup-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
}

.ct-decision-popup-notes {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
}

.ct-decision-confirmation {
  align-items: flex-start;
  text-align: left;
}

.ct-decision-confirmation .ct-decision-popup-notes {
  width: 100%;
}

.ct-decision-popup-notes textarea {
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  min-height: 96px;
  padding: 8px 10px;
  resize: vertical;
  width: 100%;
}

.ct-works-summary-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.ct-works-summary-header .button-component {
  min-width: 180px;
  width: auto;
}
.ct-works-summary-header .button-component button,
.ct-works-summary-header .button-component a {
  white-space: normal;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/RightsholderScene/CatalogTransfer/CatalogTransferView/index.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;;AAKM;EACE,qBAAA;AAFR;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AALF;;AAQA;EACE,iBAAA;EACA,gBAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AALF;;AAQA;EACE,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AALF;;AAQA;EACE,gBAAA;EACA,mBAAA;AALF;;AAQA;EACE,aAAA;EACA,SAAA;EACA,kBAAA;AALF;;AAQA;EACE,cAAA;AALF;;AAQA;EACE,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;AALF;;AAQA;EACE,gBAAA;EACA,kBAAA;AALF;;AAQA;EACE,SAAA;AALF;;AAQA;EACE,gBAAA;EACA,uBAAA;AALF;;AASE;EACE,mBAAA;AANJ;AASE;EACE,gBAAA;AAPJ;;AAWA;EACE,kBAAA;AARF;;AAWA;EACE,aAAA;EACA,yBAAA;EACA,eAAA;AARF;;AAWA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AARF;;AAWA;EACE,uBAAA;EACA,gBAAA;AARF;;AAWA;EACE,WAAA;AARF;;AAWA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AARF;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AARF;;AAWA;EACE,gBAAA;EACA,WAAA;AARF;AAUE;;EAEE,mBAAA;EACA,kBAAA;AARJ","sourcesContent":[".ct-view {\n  width: 100%;\n}\n\n.catalog-transfer-wrapper {\n  .content-header {\n    .data-container {\n      .right-data {\n        align-items: flex-end;\n      }\n    }\n  }\n}\n\n.ct-status-pill {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.ct-status-pill-label {\n  font-size: 1.6rem;\n  font-weight: 600;\n}\n\n.ct-view-heading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-top: 2.5rem;\n}\n\n.ct-review-actions {\n  background: #f2f2f2;\n  border-radius: 4px;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  padding: 18px 20px;\n  margin: 10px 0 30px;\n  width: fit-content;\n  min-width: 210px;\n}\n\n.ct-review-actions-title {\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\n.ct-review-actions-buttons {\n  display: flex;\n  gap: 18px;\n  width: fit-content;\n}\n\n.ct-review-note {\n  margin: 16px 0;\n}\n\n.ct-decision-summary {\n  background: #f2f2f2;\n  border-radius: 4px;\n  padding: 14px 16px;\n  margin: 10px 0 30px;\n  width: 210px;\n}\n\n.ct-decision-summary-title {\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.ct-decision-summary-value {\n  margin: 0;\n}\n\n.ct-decision-popup {\n  max-width: 60rem;\n  width: min(60rem, 100%);\n}\n\n.ct-decision-popup-inner {\n  h2 {\n    margin-bottom: 12px;\n  }\n\n  > p {\n    margin: 0 0 16px;\n  }\n}\n\n.ct-decision-popup-description {\n  margin: 8px 0 16px;\n}\n\n.ct-decision-popup-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 8px;\n}\n\n.ct-decision-popup-notes {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.ct-decision-confirmation {\n  align-items: flex-start;\n  text-align: left;\n}\n\n.ct-decision-confirmation .ct-decision-popup-notes {\n  width: 100%;\n}\n\n.ct-decision-popup-notes textarea {\n  border: 1px solid #d0d0d0;\n  border-radius: 4px;\n  min-height: 96px;\n  padding: 8px 10px;\n  resize: vertical;\n  width: 100%;\n}\n\n.ct-works-summary-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.ct-works-summary-header .button-component {\n  min-width: 180px;\n  width: auto;\n\n  button,\n  a {\n    white-space: normal;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
